import revive_payload_client_4sVQNw7RlN from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_9jT3W5OS8r from "/var/www/cellcom/production/frontend/.nuxt/runtime/plugin.ts";
import plugin_vue3_YdLad5Mpq3 from "/var/www/cellcom/production/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/cellcom/production/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/cellcom/production/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_kcwR6Qz4dH from "/var/www/cellcom/production/frontend/src/modules/lrud/runtime/plugin.ts";
import plugin_WBrTlpHsOa from "/var/www/cellcom/production/frontend/src/modules/notification/runtime/plugin.ts";
import plugin_Jozdw60ZsE from "/var/www/cellcom/production/frontend/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import backButton_client_nTf4sBBdRm from "/var/www/cellcom/production/frontend/src/plugins/backButton.client.ts";
import sentry_client_KAXFuL2wum from "/var/www/cellcom/production/frontend/src/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_9jT3W5OS8r,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_kcwR6Qz4dH,
  plugin_WBrTlpHsOa,
  plugin_Jozdw60ZsE,
  backButton_client_nTf4sBBdRm,
  sentry_client_KAXFuL2wum
]